function NativicationsSo(){
    return (
        <>
        <div className="nativ">
            <div className="icon">
            <i className="fa-solid fa-circle-check"></i>
            </div>
            <div className="massage">
                <p>Cv-ga Wa La cusbonaysiyay</p>
            </div>
        </div>
        </>
    )
}


export default NativicationsSo